import { DataTypeInterface } from './Utils';

export const DTYPE_STRING = 'string';
export const DTYPE_NULL = 'null';
export const DTYPE_RECORD = 'record';
export const DTYPE_BOOLEAN = 'boolean';
export const DTYPE_INT = 'int';
export const DTYPE_DOUBLE = 'double';
export const DTYPE_ARRAY = 'array';

const DATATYPE: DataTypeInterface[] = [
    { dataType: DTYPE_RECORD, id: 1, text: 'Object' },
    { dataType: DTYPE_NULL, id: 2, text: 'Null' },
    { dataType: DTYPE_BOOLEAN, id: 3, text: 'Boolean' },
    { dataType: DTYPE_STRING, id: 4, text: 'String' },
    { dataType: DTYPE_INT, id: 5, text: 'Number' },
    { dataType: DTYPE_ARRAY, id: 6, text: 'Array' },
];

export default DATATYPE;
